// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__o4QM5","footer":"ModalCreateQualiphyProcedure_footer__32Ztp","additionData":"ModalCreateQualiphyProcedure_additionData__3-QMS"};